import React, { useState, useContext, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Button, Col, Form, Input, Row, Card, Select } from 'antd';
import PageContainer from '../../../CSIComponents/PageContainer';
import { isEditStateContext, isSaveContext } from '../../../../store/editableContext'
import { post, getData } from '../apiCalls'

declare global {
  interface Window {
    otherAmenitiesExtra: {
      accessiblewashbasin: string,
      loweredsink: string,
      loweredviewportdoor: string
    },
    otherAmenityGet: {
      roomrenovationyear: string
      roomrenovationnumbers: string,
      roomrenovationpercent: string,
      dayrateavail: string,
      dayratecost: string,
      dayrateprop: string,
      dayratenote: string,
      guestlaundry: string,
      guestlaundryfee: string,
      guestlaundryhours: any,
      frontdeskhours: any,
      foodtakeaway: string,
      ccaccessavail: string,
      ccaccesscost: string,
      ccaccessprop: string,
      ccaccessnotes: string,
      cribavail: string,
      cribcost: string,
      cribprop: string,
      cribnotes: string,
      accessiblewashbasin: string,
      loweredsink: string,
      loweredviewportdoor: string,
      roomentrance: string,
      airfilter: string,
      hypoallergicroom: string,
      housekeepingtype: string,
      housekeepingfrequency: string,
      housekeepingdailyfee: string,
      closures: any,
      otheramenityid: number
    }
  }
}

const Extra = () => {

  const [AccessibleWashBasins, setAccessibleWashBasins] = useState('')
  const [LoweredSink, setLoweredSink] = useState('')
  const [LoweredViewportInTheDoor, setLoweredViewportInTheDoor] = useState('')
  const [form] = Form.useForm();
  const { Option } = Select;

  const context = useContext(isEditStateContext)
  const saveContext = useContext(isSaveContext)

  const [rateProperties] = useState<string[]>([
    'Yes', 
    'No'
  ]) 
  const [ready, setReady] = useState<boolean>(false)

  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const saveAction = async () => {
    const body = {
      "accessiblewashbasin": AccessibleWashBasins,
      "loweredsink": LoweredSink,
      "loweredviewportdoor": LoweredViewportInTheDoor
    }
    window.otherAmenitiesExtra = body
    await post()
    await getData()
  }

  useEffect(() => {
    // adding listeners
    const get = async () => {
      setAccessibleWashBasins(window.otherAmenityGet.accessiblewashbasin)
      setLoweredSink(window.otherAmenityGet.loweredsink)
      setLoweredViewportInTheDoor(window.otherAmenityGet.loweredviewportdoor)
      setReady(true)
    }
    get()
  },[])

  useEffect(() => {
    if (saveContext) {
      saveAction()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[saveContext])

  useEffect(() => {
    if (context) {
      // removing action buttons
      const buttons: any = document.getElementsByClassName('ligthButton')
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].classList.add('d-none')
      }
    }
  },[context])

  return (
    <>
      { ready ?
        
        <Card style={{ margin: '16px'}}>
          <Grid container spacing={0} className="containerSpacing py-0">
            <Grid item xs={12} className="p-0">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>Extra Accessible Feature & Security</div>
                  <div className={context ? 'd-none' : ''}>
                    <Button 
                      style={{ background: '#004771', color: '#fff', width: 60, height: 28 }} 
                      onClick={() => { window.editFunction() }}>
                        Edit
                      </Button>
                  </div>
              </div>
            </Grid>
            <Grid item xs={12} className={!context ? "pb-0 px-0 my-0 is-disabled-fields" : "pb-0 px-0 my-0"}>
              <Form
                layout="vertical"
                form={form}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{
                  "AccessibleWashBasins": AccessibleWashBasins,
                  "LoweredSink": LoweredSink, 
                  "LoweredViewportInTheDoor": LoweredViewportInTheDoor
                }}
              >
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      name='AccessibleWashBasins'
                      label="Accessible Wash Basins">
                      <Select allowClear onChange={(e: string) => setAccessibleWashBasins(e)}
                        showSearch
                      >
                        {
                          rateProperties.map((rt: string, index: number) => (
                            <Option value={rt} key={index}>{rt}</Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name='LoweredSink'
                      label="Lowered Sink">
                      <Select allowClear onChange={(e: string) => setLoweredSink(e)}
                        showSearch
                      >
                        {
                          rateProperties.map((rt: string, index: number) => (
                            <Option value={rt} key={index}>{rt}</Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name='LoweredViewportInTheDoor'
                      label="Lowered Viewport In The Door">
                      <Select allowClear onChange={(e: string) => setLoweredViewportInTheDoor(e)}
                        showSearch
                      >
                        {
                          rateProperties.map((rt: string, index: number) => (
                            <Option value={rt} key={index}>{rt}</Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Grid>
          </Grid>
        </Card>
      : <></>}
    </>
  )
}

export default Extra
